import { Component, OnInit, ViewEncapsulation, OnDestroy, Input, Output, EventEmitter } from '@angular/core';
import { Subscription, forkJoin } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { AppManagerService } from './app-manager.service';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { DialogComponent } from './dialog/dialog.component';

export interface Section {
  name: string;
  icon?: string;
  link?: string;
}

@Component({
  selector: 'dhhp-appManager',
  templateUrl: './app-manager.component.html',
  styleUrls: ['./app-manager.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class AppManagerComponent implements OnInit, OnDestroy {
  topLists: Section[];
  appLists: any;
  emitData: any;
  AppsList: any;
  subscribeAlert: boolean = false;
  url: string;
  formData: any;
  doNotShowLink: boolean = false;
  appName: string;
  dataToPass: string;
  appStatus: string;
  @Input() platformURL: string = '';
  @Input() redirectPath: string = '';
  @Input() doShowDashboard: boolean = false;
  formDataUpdate: any;
  profileData: any;
  getCurrentAppInfo: any = { applicationDetails: { isSubscriptionApprovalRequired: true, isUnsubscribeApprovalRequired: true } };
  getAllListSub: Subscription;
  @Input() RightNavData: any;
  @Output() failureEvent = new EventEmitter();
  @Output() successEvent = new EventEmitter();
  @Output() emitEvent = new EventEmitter();
  @Input() endpoint: string;
  @Input() pinpoint: string;
  @Input() apiSignature: string;
  @Input() topSection: any;
  newLists: any;
  @Input() listofApps: any;
  hideSubscribe: boolean = false;
  @Input() princibleID: string = "";
  pinnedApps;
  subscription: Subscription;
  subscriptionData: Subscription;

  constructor(private dialogBox: MatDialog, public translate: TranslateService, private _http: AppManagerService, private router: Router) { }

  ngOnInit() {
    if (!!localStorage.getItem('userObject')) {
      this.profileData = JSON.parse(localStorage.getItem('userObject'));
      if (this.profileData.accountType == 'Hartmann') {
        this.hideSubscribe = true;
      }
    }
    this.url = this.endpoint + this.apiSignature
    this.topLists = this.topSection;
    this.getAllApps();
    this.subscriptionData = this._http.refreshIndex$.subscribe(data => {
      this.appLists = JSON.parse(localStorage.getItem('featureList'));
      this.appLists = JSON.parse(localStorage.getItem('featureList')).filter((x) => {
        return (x.isUserSubscribed && x.isUserApproved);
      })
      this.newLists = JSON.parse(localStorage.getItem('featureList')).filter((x) => {
        return ((!x.isUserApproved && !x.isUserSubscribed) || (!x.isUserApproved && x.isUserSubscribed));
      })
    })
    this.subscription = this._http.unPinIndex$.subscribe(data => {
      if (data) {
        this.getAllApps();
      }
    })
  }
  
  isAppAvailableForCountry(item) {
    try {
      var isAppAvailable = item.applicationSettings.filter(res => res.country == localStorage.getItem('countryVal'));
      return isAppAvailable.length > 0 ? true : false;
    } catch (e) {
      return false;
    }

  }

  getAppName(item) {
    if (item.applicationSettings.length > 0) {
      var isAppAvailable = item.applicationSettings.filter(res => res.country == localStorage.getItem('countryVal'));
      if (isAppAvailable.length > 0) {
        var selLang = localStorage.getItem('Lang').split('-')[0];
        var appDetails = isAppAvailable[0].applicationDetails.translationDetails.filter(res => res.languageCode == selLang);
        if (appDetails.length > 0) {
          if (appDetails[0].appName != "") {
            return appDetails[0].appName;
          } else {
            var appName = item.countryAppNames.filter(res => res.country == localStorage.getItem('countryVal'));
            if (appName.length > 0) {
              return appName[0].appName;
            } else {
              return item.appName;
            }
          }
        } else {
          var appName = item.countryAppNames.filter(res => res.country == localStorage.getItem('countryVal'));
          if (appName.length > 0) {
            return appName[0].appName;
          } else {
            return item.appName;
          }
        }
      } else {
        var appName = item.countryAppNames.filter(res => res.country == localStorage.getItem('countryVal'));
        if (appName.length > 0) {
          return appName[0].appName;
        } else {
          return item.appName;
        }
      }
    } else {
      var appName = item.countryAppNames.filter(res => res.country == localStorage.getItem('countryVal'));
      if (appName.length > 0) {
        return appName[0].appName;
      } else {
        return item.appName;
      }
    }
  }

  getAllApps() {
    this.getAllListSub = forkJoin(
      this._http.getApps(this.url),
    ).subscribe({
      next: ([data]) => {
        this.appLists = data;
        if (data) {
          this.appLists = data.filter((x) => {
            return (x.isUserSubscribed && x.isUserApproved);
          })
          this.newLists = data.filter((x) => {
            return ((!x.isUserApproved && !x.isUserSubscribed) || (!x.isUserApproved && x.isUserSubscribed));
          })
        }
      }
    })
  }
  
  RemovePinfromUserDashboard(id, i) {
    this._http.deleteApi(this.pinpoint + "PintoUserDashboard/RemovePinfromUserDashboard/" + id).subscribe({
      next: data => {
        this.appLists[i].pinToDashboardId = null;
        this.emitEvent.emit({ event: "removePinData" })
      },
      error: err => {
      }
    })
  }

  AddPinToUserDashboard(note, i) {
    var data = {
      "name": note.appName,
      "iconUrl": note.appIconUrl,
      "iconHoverUrl": note.appIconUrl,
      "description": note.shortDescription,
      "typeofApp": "Application",
      "applicationUrl": note.appUrl,
      "userId": this.princibleID,
      "createdOn": new Date().toISOString(),
      "country": localStorage.getItem('countryVal')
    }
    this._http.postApi(this.pinpoint + "PintoUserDashboard/AddPinToUserDashboard", data).subscribe({
      next: data => {
        this.appLists[i].pinToDashboardId = data.pinToDashboardId;
        this.emitEvent.emit({ event: "addPinData" })
      },
      error: err => {
      }
    })
  }

  getPinnedDashboardAppsforUser() {
    this._http.getApi(this.pinpoint + "PintoUserDashboard/GetPinnedDashboardAppsforUser/").subscribe({
      next: data => {


      },
      error: err => {
        console.log("AppManager: Error in getting pinned dashboard app for user.")
      }
    })
  }

  subscribeAPPDirectly(formData, index) {
    this._http.subscribeAppDirectly(this.endpoint + "AppSubscription/AddDefaultSubScriptionByClientApp", formData).subscribe({
      next: data => {
        if (data) {
          const dataView = this.newLists.find(res => { return res.appKey == formData.appId });
          if (dataView)
            dataView.isUserApproved = true;
          dataView.isUserSubscribed = true;
          this.appLists[this.appLists.length] = dataView;
          this.newLists.splice(index, 1)
          this.emitEvent.emit({ event: 'setSubscriptionValue', val: data });
        }
      },
      error: err => {
        if (!!err)
          this.emitEvent.emit({ event: "subscribeAlert", val: err.error.message });
      }
    })
  }

  subscribeAPP(formData, index) {
    this._http.subscribeAPP(this.endpoint + "AppSubscription/AddSubScriptionRequest", this.formData).subscribe({
      next: data => {
        if (data.isUserApproved && data.isUserSubscribed) {
          this.appLists[this.appLists.length] = data;
          this.newLists.splice(index, 1)
        } else if (!data.isUserApproved && data.isUserSubscribed) {
          this.newLists[index] = data;
          this.subscribeAlert = true;
          this.successCallEvent(data, 'subscribe');
        }
        this.emitEvent.emit({ event: 'setSubscriptionValue', val: data });
      },
      error: err => {
        if (!!err)
          this.emitEvent.emit({ event: "subscribeAlert", val: err.error.message });
      }
    })
  }

  exploreDetails() {
    this.router.navigateByUrl('/dashboard/explore', { state: { tab: 1 } });
  }

  appSubscription(appID, index) {
    this.formData = {
      appId: appID.appKey,
      userId: this.princibleID,
      country: localStorage.getItem('countryVal')
    };
    if (appID.applicationSettings.length) {
      this.getCurrentAppInfo = appID.applicationSettings.find(res => res.country == this.profileData.country);
    }
    if (appID.isUserSubscribed == false) {
      if (this.getCurrentAppInfo && !this.getCurrentAppInfo.applicationDetails.isSubscriptionApprovalRequired) {
        let formData = {
          userId: this.profileData.userId,
          appId: appID.appKey,
          country: localStorage.getItem('countryVal')
        }
        this.subscribeAPPDirectly(formData, index);
      } else {
        var associatedAccounts = JSON.parse(localStorage.getItem('userObject'));
        associatedAccounts = associatedAccounts.associatedAccounts[0];
        if (associatedAccounts && this.getCurrentAppInfo && this.getCurrentAppInfo.isPaidApp) {
          this._http.getFacilitySubscriptionForApps(this.endpoint + "AppSubscription/GetFacilitySubscriptionPlansforApp/" + appID.appKey + "/" + associatedAccounts.facilityCRMId + "/" + localStorage.getItem('countryVal')).subscribe(data => {
            if (data) {
              if (data.length) {
                this.subscribeAPP(this.formData, index)
              } else {
                this.emitEvent.emit({ event: 'navigateToExplore', val: appID, redirectURL: this.redirectPath });
              }
            }
          })
        } else {
          this.subscribeAPP(this.formData, index)
        }
      }
    }
    if (appID.isUserSubscribed == true) {
      this.formDataUpdate = {
        appId: appID.appKey,
        userId: this.princibleID
      };
      if (!this.getCurrentAppInfo.applicationDetails.isUnsubscribeApprovalRequired) {
        const formData = {
          appId: appID.appKey,
          userId: this.princibleID,
          isApproved: true,
          country: localStorage.getItem('countryVal')
        }
        this._http.deSubscribeApp(this.endpoint + "AppSubscription/DesubscribeRequest", formData).subscribe({
          next: data => {
            if (data) {
              this.newLists[this.newLists.length] = data;
              this.appLists.splice(index, 1);
              this.emitEvent.emit({ event: 'setSubscriptionValue', val: data });
            }
          },
          error: err => {
            if (!!err && err.status == 500) {
              this.failureEvent.emit(err);
            }
          }
        })
      } else {
        const dialogRef = this.dialogBox.open(DialogComponent, {
          width: '500px',
          disableClose: true
        });
        this.dataToPass = this.translate.instant('approve-unsubscribe')
        dialogRef.componentInstance.confirmData = this.dataToPass;
        dialogRef.afterClosed().subscribe(result => {
          if (result.event === 'confirm') {
            this.formDataUpdate.comments = result.notes;
            this.formDataUpdate.country = localStorage.getItem('countryVal');
            this._http.subscribeAPP(this.endpoint + "AppSubscription/AddDeSubScriptionRequest", this.formDataUpdate).subscribe({
              next: data => {
                this.subscribeAlert = true;
                this.newLists[this.newLists.length] = data;
                this.appLists.splice(index, 1)
                this.successCallEvent(data, 'desubscribe');
                this.emitEvent.emit({ event: 'setSubscriptionValue', val: data });
              },
              error: err => {
                this.failureEvent.emit(err);
              }
            })
          }
        });
      }
    }
  }

  successCallEvent(data, flag) {
    this.appName = data.appName;
    if (flag == 'desubscribe') {
      this.appStatus = "desubscription"
    } else {
      this.appStatus = "subscription"
    }
    setTimeout(() => {
      this.subscribeAlert = false;
    }, 7000);
  }

  getMainPanel(data) {
    if (data.isUserApproved && data.isUserSubscribed) {
      window.location.href = data.appUrl;
    }
  }

  righNavClose() {
    this.RightNavData.toggle();
  }
  redirectPlatform() {
    if (this.platformURL != '') {
      window.location.href = this.platformURL;
    }
  }
  
  ngOnDestroy() {
    if (this.subscription)
      this.subscription.unsubscribe();
  }
}
